export default {
    legalEntities: [],
    dateTypeIds: []
};
